// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/global_alert_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/global_alert_model.proto.
 */
export const file_bffuser_v1_global_alert_model: GenFile = /*@__PURE__*/
  fileDesc("CiNiZmZ1c2VyL3YxL2dsb2JhbF9hbGVydF9tb2RlbC5wcm90bxIKYmZmdXNlci52MSItChRPY2N0b0NyZWRlbnRpYWxBbGVydBIVCg1idXNpbmVzc19jb2RlGAEgASgJQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM");

/**
 * OcctoCredentialAlert is one OCCTO 事業者コード under the 認証情報不備 warning
 * (spec plan-common.md AC-PLC-053). Mirrors internalapi.v1.OcctoCredentialAlert.
 *
 * @generated from message bffuser.v1.OcctoCredentialAlert
 */
export type OcctoCredentialAlert = Message<"bffuser.v1.OcctoCredentialAlert"> & {
  /**
   * OCCTO 事業者コード (4 digits).
   *
   * @generated from field: string business_code = 1;
   */
  businessCode: string;
};

/**
 * Describes the message bffuser.v1.OcctoCredentialAlert.
 * Use `create(OcctoCredentialAlertSchema)` to create a new message.
 */
export const OcctoCredentialAlertSchema: GenMessage<OcctoCredentialAlert> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_global_alert_model, 0);

